/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  handle: function handle(app, data): void {
    if (data.eventPrintsMachineId) {
      localStorage.setItem('eventPrintsMachineId', data.eventPrintsMachineId)
    }
  },
}
